module.exports = __webpack_public_path__ + "static/phone-slide-3-80681df0264b7bfbe9e395fcb4735aa4.png";